import type { Menu } from '../../shared/menu';
import { useCart, cartItemCount } from '../lib/store';
import { useT } from '../lib/i18n';
import { formatPrice } from '../../shared/currencies';
import { findDish } from '../../shared/menu';

interface CartPillProps {
  menu: Menu;
  onClick: () => void;
}

export function CartPill({ menu, onClick }: CartPillProps) {
  const cart = useCart((s) => s.cart);
  const t = useT();
  const count = cartItemCount(cart);
  if (count === 0) return null;

  const total = (cart?.lines ?? []).reduce((acc, l) => {
    const found = findDish(menu, l.dishId);
    if (!found?.dish.price) return acc;
    return acc + found.dish.price * l.quantity;
  }, 0);

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        padding: 'max(12px, env(safe-area-inset-bottom)) 16px max(20px, env(safe-area-inset-bottom))',
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 30,
      }}
    >
      <button
        onClick={onClick}
        style={{
          pointerEvents: 'auto',
          background: 'var(--color-accent)',
          color: '#fff',
          border: 'none',
          padding: '14px 22px',
          borderRadius: 9999,
          minHeight: 56,
          fontSize: 15,
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 14,
          boxShadow: 'var(--shadow-pill)',
          maxWidth: '90%',
        }}
      >
        <span className="num" style={{ minWidth: 22, textAlign: 'center' }}>
          {count > 99 ? '99+' : count}
        </span>
        <span style={{ flex: 1, textAlign: 'left' }}>
          {t('cart.viewOrder')} · {count > 99 ? '99+' : count} {t('cart.items')}
        </span>
        {total > 0 && (
          <span className="num" style={{ opacity: 0.95 }}>{formatPrice(total, menu.currency)}</span>
        )}
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </div>
  );
}
